export default "__VITE_ASSET__BqR80lEv__"